import React, { Component, Fragment } from 'react';
import { PDFViewer } from '@react-pdf/renderer';
import Report3 from './R3';
// import Invoice from "./components/reports/Invoice";
// import invoice from "./data/invoice";
// import InvoiceDemain from "./components/reports/InvoiceDamian";
// import InvoiceDamianTable from "./components/reports/InvoiceDamianTable";
import R2 from 'pages/stepper4/components/reports/R2';

// import logo from './logo.svg';
import './R3.css';

// from HrInspectionReport.jsx
// App.js, NinjaMain.js

class App extends Component {
  render() {
    return (
      <Fragment>
        {/* <PDFViewer width="1000" height="600" className="app"> */}
        {/* <Invoice invoice={invoice} /> */}
        {/* <InvoiceDemain /> */}
        <R2 />
        {/* </PDFViewer> */}
      </Fragment>
    );
  }
}

export default App;
